import { HttpClient, HttpParams } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { BehaviorSubject, tap } from 'rxjs'
import { environment } from '../../../../environments/environment'
import { FailedJobModel, JobModel } from '../../../core/models/job.model'

interface JobPaginatedResponse<T> {
  status: number
  data: T[]
  meta: {
    current_page: number
    per_page: number
    total: number
    last_page: number
  }
  message: string
}

@Injectable({
  providedIn: 'root',
})
export class JobService {
  private http = inject(HttpClient)
  private apiUrl = environment.apiUrl

  private pendingJobs = new BehaviorSubject<JobModel[]>([])
  private failedJobs = new BehaviorSubject<FailedJobModel[]>([])
  private pendingTotal = new BehaviorSubject<number>(0)
  private failedTotal = new BehaviorSubject<number>(0)
  private pendingLoading = new BehaviorSubject<boolean>(false)
  private failedLoading = new BehaviorSubject<boolean>(false)

  public pendingJobs$ = this.pendingJobs.asObservable()
  public failedJobs$ = this.failedJobs.asObservable()
  public pendingTotal$ = this.pendingTotal.asObservable()
  public failedTotal$ = this.failedTotal.asObservable()
  public pendingLoading$ = this.pendingLoading.asObservable()
  public failedLoading$ = this.failedLoading.asObservable()

  getPendingJobs(page = 1, perPage = 15) {
    this.pendingLoading.next(true)
    const params = new HttpParams().set('page', page).set('perPage', perPage)
    return this.http
      .get<
        JobPaginatedResponse<JobModel>
      >(`${this.apiUrl}/jobs/pending`, { params })
      .pipe(
        tap((res) => {
          this.pendingJobs.next(res.data)
          this.pendingTotal.next(res.meta.total)
          this.pendingLoading.next(false)
        })
      )
  }

  getFailedJobs(page = 1, perPage = 15) {
    this.failedLoading.next(true)
    const params = new HttpParams().set('page', page).set('perPage', perPage)
    return this.http
      .get<
        JobPaginatedResponse<FailedJobModel>
      >(`${this.apiUrl}/jobs/failed`, { params })
      .pipe(
        tap((res) => {
          this.failedJobs.next(res.data)
          this.failedTotal.next(res.meta.total)
          this.failedLoading.next(false)
        })
      )
  }
}
